import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RouterActivate } from '@app/shared/services/router.activate.service';
import { OtpSetupComponent } from '@app/features/otp/otp-setup/otp-setup.component';
import { OtpVerifiedComponent } from '@app/features/otp/otp-verified/otp-verified.component';
import { OtpErrorComponent } from '@app/features/otp/otp-error/otp-error.component';

const routes: Routes = [
  { path: '', component: OtpVerifiedComponent },
  { path: 'setup', component: OtpSetupComponent },
  { path: 'verified', component: OtpVerifiedComponent, /* canActivate: [RouterActivate] */ },
  { path: 'error', component: OtpErrorComponent, /* canActivate: [RouterActivate] */ },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OtpRoutingModule { }
